import router from "../router";
import toastr from "toastr";
let intentos = 0;
let no_ha_reproducido = true;
export default {
  namespaced: true,
  state: {
    userid: null,
    registerNombre: "",
    registerUser: "",
    registerEmail: "",
    registerPassword: "",
    registerError: null,
    loginUser: "",
    loginPassword: "",
    loginError: null,
    token: null,
    refreshToken: null,
    empresas: [],
    empresa_id:1,
    rol:0,
    autorizaComprobantes:0,
    cerrarMes:0,
  },
  actions: {
    setEmpresa({commit}, payload) {
      commit("setEmpresaSelect",payload)
    },
    logout({ commit }) {
      commit("setToken", null);
      commit("setRefreshToken", null);
      commit("setIdUser", null);
      commit("setEmpresas", []);
      router.push("/login");
      //window.location = "/login";
    },
    register({ commit, state }) {
      commit("setRegisterError", null);
      if (state.registerPassword.length < 6)
        return toastr["error"]("El password debe ser de 6 a más caracteres");

      var regex = new RegExp(
        // eslint-disable-next-line no-useless-escape
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*_,};{\/[\]\-\\.?\^\'\`+&"!|¬°´()#])[A-Za-z\d$@$!%*_,};{\/[\]\-\\.?\^\'\`+&"!|¬°´()#]{6,30}$/
      );
      if (regex.test(state.registerPassword)) {
        if (
          state.registerUser !== null &&
          state.registerEmail !== null &&
          state.registerPassword !== null &&
          state.registerNombre !== null
        ) {
          // eslint-disable-next-line no-undef
          return axios.post("/api/auth/register", {
              nombre: state.registerNombre,
              username: state.registerUser,
              password: state.registerPassword,
              email: state.registerEmail
            })
            .then(data => {
              console.log(data);
              if (data.data.status == "ok") {
                commit("setRegisterNombre", "");
                commit("setRegisterUser", "");
                commit("setRegisterPassword", "");
                commit("setRegisterEmail", "");
                router.push("/users");
                return toastr["success"]("Usuario Creado correctamente");
              } else {
                commit("setRegisterUser", "");
                commit("setRegisterEmail", "");
                commit("setRegisterNombre", "");
                return toastr["error"](
                  "Verifique si esta completando todos los datos y no usar un Nombre, Usuario o Email ya registrado"
                );
              }
            })
            .catch(err => {
              commit("setRegisterUser", null);
              commit("setRegisterPassword", null);
              commit("setRegisterEmail", null);
              commit("setRegisterNombre", null);
              commit(
                "setRegisterError",
                "Verifique si esta completando todos los datos y no usar un Nombre, Usuario o Email ya registrado"
              );
              const msj = err.response.data.error.message;
              if (msj.includes("users_username_unique")) {
                commit(
                  "setRegisterError",
                  "Nombre de Usuario Ya ha sido Registrado, favor elija otro"
                );
              } else if (msj.includes("users_email_unique")) {
                commit(
                  "setRegisterError",
                  "Email Ya ha sido Registrado, favor elija otro"
                );
              } else {
                commit("setRegisterError", msj);
              }
              return toastr["error"](state.registerError);
            });
        } else {
          commit("setRegisterError", "Favor Complete los datos");
          commit("setRegisterNombre", null);
          commit("setRegisterUser", null);
          commit("setRegisterPassword", null);
          commit("setRegisterEmail", null);
          return toastr["error"](state.registerError);
        }
      } else {
        commit("setRegisterPassword", null);
        toastr.options = {
          closeButton: true,
          debug: false,
          newestOnTop: false,
          progressBar: true,
          positionClass: "toast-top-right",
          preventDuplicates: true,
          onclick: null,
          showDuration: "300",
          hideDuration: "1000",
          timeOut: "10000",
          extendedTimeOut: "15000",
          showEasing: "swing",
          hideEasing: "linear",
          showMethod: "fadeIn",
          hideMethod: "fadeOut"
        };
        return toastr["error"](
          `Se requiere: por lo menos una letra en <strong>Mayúscula</strong>, un <strong>Número</strong> y un <strong>Carácter Especial</strong>
                    (Ejem: ?&\\"{[-+$@!%*_,};].!|¬°´?#])`,
          "Favor Usar Contraseñas Seguras"
        );
      }
    },
    login({ commit, state }) {
      commit("setLoginError", null);
      if (state.loginUser == "" || state.loginPassword == "") {
        commit("setLoginError", "Ingresar datos");
        return toastr["error"](state.loginError);
      }

      // eslint-disable-next-line no-undef
      return axios.post("/api/auth/login", {
          username: state.loginUser,
          password: state.loginPassword
        })
        .then(({ data }) => {
          if (data.status == "Fail") {
            commit("setLoginError", "Credenciales Incorrectas");
            intentos++;
            if (intentos == 5)
              return toastr["error"](
                "Si intentas otra vez y te equivocas de credenciales te llevaras una sorpresa"
              );
            if (intentos > 5) return hs();
            return toastr["error"](state.loginError);
          }
          commit("setRegisterNombre", "");
          commit("setLoginUser", "");
          commit("setLoginPassword", "");
          commit("setRegisterEmail", "");
          commit("setToken", data.token);
          commit("setRefreshToken", data.refreshToken);
          commit("setIdUser", data.id);
          commit("setRol", data.rol);
          commit("setCerrarMes", data.cerrar_mes);
          commit("setAutorizarComprobante", data.autoriza_comprobantes);
          commit("setEmpresas", data.empresas);
          commit("setEmpresaSelect", data.empresas[0].value);


          window.axios.defaults.headers.common = {
            Authorization: `Bearer ${data.token}`
          };
          router.push("/");
        })
        .catch(() => {
          intentos++;
          if (intentos == 5)
            return toastr["error"](
              "Si intentas otra vez y te equivocas de credenciales te llevaras una sorpresa"
            );
          if (intentos > 5) return hs();
          commit("setLoginError", "Credenciales Incorrectas");
          return toastr["error"](state.loginError);
        });
    },
    forgotPass({ commit, state }) {
      if (!state.loginUser || state.loginUser.trim() < 4)
        return toastr["error"](
          "Para solicitar la recuperación debe ingresar un usuario valido"
        );

      // eslint-disable-next-line no-undef
      return axios.post("/api/auth/reset", { username: state.loginUser })
        .then(({ data }) => {
          return data.status === "Ok"
            ? toastr["success"](
                "Solicitud procesada con éxito, revise su correo y siga las instrucciones"
              )
            : toastr["error"](data.desc);
        })
        .catch(() => {
          commit(
            "setLoginError",
            "Error procesando la petición, debe ingresar un usuario valido"
          );
          return toastr["error"](state.loginError);
        });
    },
    newPass({ commit, state }) {
      let regex = new RegExp(
        // eslint-disable-next-line no-useless-escape
        /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*_,};{\/[\]\-\\.?\^\'\`+&"!|¬°´()#])[A-Za-z\d$@$!%*_,};{\/[\]\-\\.?\^\'\`+&"!|¬°´()#]{6,30}$/
      );
      if (!regex.test(state.loginPassword)) {
        toastr[
          "error"
        ](`Se requiere: por lo menos una letra en <strong>Mayúscula</strong>,
        un <strong>Número</strong> y un <strong>Carácter Especial</strong>
                    (Ejem: ?&\\"{[-+$@!%*_,};].!|¬°´?#])`);
        return;
      }
      // eslint-disable-next-line no-undef
      return axios.post("/api/auth/genNewPass", {
          pass: state.loginPassword,
          token: router.currentRoute.query.t
        }).then(({ data }) => {
          if (data.status === "Ok") {
            toastr["success"]("Contraseña cambiada exitosamente");
            toastr["info"]("Esperando para ser redirigido automáticamente");
            setTimeout(() => router.push("/"), 500);
          } else toastr["error"](data.desc);
        })
        .catch(() => {
          commit("setLoginError", "Error procesando la petición");
          return toastr["error"](state.loginError);
        });
    }
  },
  getters: {
    empresaId(state){
      return state.empresa_id;
    },
    IdLogin(state) {
      return state.userid;
    },
    isLoggedIn(state) {
      return !!state.token;
    },
    getToken(state) {
      return state.token;
    },
    getEmpresas(state) {
      return state.empresas;
    },
    getRol(state) {
      return state.rol;
    },
    getCerrarMes(state){
      return state.cerrarMes
    },
    getAutorizaComprobantes(state){
      return state.autorizaComprobantes
    },
  },
  mutations: {
    setEmpresaSelect(state, empresa) {
      state.empresa_id = empresa;
    },
    setToken(state, token) {
      state.token = token;
    },
    setRefreshToken(state, token) {
      state.refreshToken = token;
    },
    setRegisterError(state, error) {
      state.registerError = error;
    },
    setRegisterUser(state, username) {
      state.registerUser = username;
    },
    setRegisterNombre(state, nombre) {
      state.registerNombre = nombre;
    },
    setRegisterPassword(state, password) {
      state.registerPassword = password;
    },
    setRegisterEmail(state, email) {
      state.registerEmail = email;
    },
    setLoginError(state, error) {
      state.loginError = error;
    },
    setLoginUser(state, username) {
      state.loginUser = username;
    },
    setLoginPassword(state, password) {
      state.loginPassword = password;
    },
    setIdUser(state, userid) {
      state.userid = userid;
    },
    setEmpresas(state, empresas) {
      state.empresas = empresas;
    },
    setRol(state, rol) {
      state.rol = rol;
    },
    setCerrarMes(state, cerrarMes) {
      state.cerrarMes = cerrarMes;
    },
    setAutorizarComprobante(state, autorizaComprobantes) {
      state.autorizaComprobantes = autorizaComprobantes;
    }
  }
};

function hs() {
  console.log(no_ha_reproducido);
  if (no_ha_reproducido) {
    no_ha_reproducido = false;
    toastr["error"]("🏴‍☠️ Ajá!  eres un Hackerman 😁");
    !(function() {
      function e(e) {
        var t = (function(e) {
          return { height: e.offsetHeight, width: e.offsetWidth };
        })(e);
        return t.height > a && t.height < r && t.width > i && t.width < s;
      }
      function t(e) {
        var t = (function(e) {
          for (var t = e, n = 0; t; ) (n += t.offsetTop), (t = t.offsetParent);
          return n;
        })(e);
        return t >= g && t <= p + g;
      }
      function n(e) {
        e.className += " " + m + " " + l[Math.floor(Math.random() * l.length)];
      }
      function o() {
        for (
          var e = document.getElementsByClassName(m),
            t = new RegExp("\\b" + m + "\\b");
          0 < e.length;

        )
          e[0].className = e[0].className.replace(t, "");
      }
      for (
        var a = 30,
          i = 30,
          r = 350,
          s = 350,
          d ="harlem-shake.mp3",
          m = "mw-harlem_shake_me",
          u = "im_first",
          l = ["im_drunk", "im_baked", "im_trippin", "im_blown"],
          c = "mw-strobe_light",
          h ="harlem-shake-style.css",
          f = "mw_added_css",
          p = (function() {
            var e = document.documentElement;
            return window.innerWidth
              ? window.innerHeight
              : e && !isNaN(e.clientHeight)
              ? e.clientHeight
              : 0;
          })(),
          g = window.pageYOffset
            ? window.pageYOffset
            : Math.max(
                document.documentElement.scrollTop,
                document.body.scrollTop
              ),
          w = document.getElementsByTagName("*"),
          b = null,
          v = 0;
        v < w.length;
        v++
      ) {
        if (e((E = w[v])) && t(E)) {
          b = E;
          break;
        }
      }
      if (null !== E) {
        !(function() {
          var e = document.createElement("link");
          e.setAttribute("type", "text/css"),
            e.setAttribute("rel", "stylesheet"),
            e.setAttribute("href", h),
            e.setAttribute("class", f),
            document.body.appendChild(e);
        })(),
          (function() {
            var e = document.createElement("audio");
            e.setAttribute("class", f),
              (e.src = d),
              (e.loop = !1),
              e.addEventListener(
                "canplay",
                function() {
                  setTimeout(function() {
                    b.className += " " + m + " " + u;
                  }, 500),
                    setTimeout(function() {
                      o(),
                        (function() {
                          var e = document.createElement("div");
                          e.setAttribute("class", c),
                            document.body.appendChild(e),
                            setTimeout(function() {
                              document.body.removeChild(e);
                            }, 100);
                        })();
                      for (var e = 0; e < y.length; e++) n(y[e]);
                    }, 15500);
                },
                !0
              ),
              e.addEventListener(
                "ended",
                function() {
                  o(),
                    (function() {
                      for (
                        var e = document.getElementsByClassName(f), t = 0;
                        t < e.length;
                        t++
                      )
                        document.body.removeChild(e[t]);
                    })();
                },
                !0
              ),
              (e.innerHTML =
                " <p>If you are reading this, it is because your browser does not support the audio element. We recommend that you get a new browser.</p> <p>"),
              document.body.appendChild(e),
              e.play();
          })();
        var y = [];
        for (v = 0; v < w.length; v++) {
          var E;
          e((E = w[v])) && y.push(E);
        }
      } else
        console.warn(
          "Could not find a node of the right size. Please try a different page."
        );
    })();
  }
}
